import { createContext, useContext, useState } from "react";
import RkCtxBo from "./RkCtxBo";

// *** Rechenkern Context 
const RkCtx = createContext<RkCtxBo>(new RkCtxBo());
const RkCtxAction = createContext((prevState: RkCtxBo) => { });

// *** Context Provider
export const RkCtxProvider: React.FC = ({ children }) => {

    // ***************************
    // Context state
    // ***************************
    // Unterschied useReducer und useState: 
    // useReducer bietet mit der reducer Funktion (siehe oben) die Basis an, um ein neues Objekt zu erzeugen.
    // Erst wenn ein neues Objet erzeugt wurde, werden die abhängigen React Komponenten neu gerendert.
    // const [appState, dispatch] = React.useReducer(AppContextReducer, new AppStateBo());
    const [rkCtxBo, setRkCtxBo] = useState(new RkCtxBo());

    const setRkCtxBoClone = (bo: RkCtxBo) => {
        setRkCtxBo({ ...bo });
    }

    return <RkCtx.Provider value={rkCtxBo}>
        <RkCtxAction.Provider value={setRkCtxBoClone}>
            {children}
        </RkCtxAction.Provider>
    </RkCtx.Provider >
}

// *** Context Consumer
const useRkCtxBo = () => {
    return useContext(RkCtx);
}

export default useRkCtxBo;

// ****************************
// Action / Reducer
// ****************************
export const useRkCtxAction = () => {
    return useContext(RkCtxAction);
}